const destopLiStyles={ 
    display: "inline-flex",
    margin: "0",
    width: "4vw",
    maxWidth: "44px",
    padding:"8px 8px"
  }

const mobileLiStyles={ 
    backgroundColor:"#000",
    display: "block",
    width: "2.25em",
    height: "2.25em",
    color: "#fff",
    fontFamily: "Roboto",
    fontSize: "1.25em",
    fontWeight: "900",
    lineHeight: "1.875em",
    textAlign: "center",
    float: "left",
    marginRight: "2.1875em",
    marginTop: "1em",
    WebkitBoxSizing: "border-box",
    boxSizing: "border-box",
    paddingTop: "5px"
  }
  
const letterStyles = {
    liStyles:window.innerWidth>899?destopLiStyles:mobileLiStyles,
  }

export default letterStyles;
